const ChevronDown = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.646 9.146a.5.5 0 0 1 .708 0L12 13.793l4.646-4.647a.5.5 0 0 1 .708.708l-5 5a.5.5 0 0 1-.708 0l-5-5a.5.5 0 0 1 0-.708"
      clipRule="evenodd"
    />
  </>
)
export default ChevronDown
